import { createStore } from "vuex";

export default createStore({
  state: {
    // Tutaj możesz dodać stan aplikacji
    user: null,
    isLoggedIn: false,
  },
  getters: {
    // Gettery dla odczytywania stanu
    getUser: (state) => state.user,
    isLoggedIn: (state) => state.isLoggedIn,
  },
  mutations: {
    // Mutacje do zmiany stanu
    SET_USER(state, user) {
      state.user = user;
      state.isLoggedIn = !!user;
    },
    LOGOUT(state) {
      state.user = null;
      state.isLoggedIn = false;
    },
  },
  actions: {
    // Akcje do wykonywania asynchronicznych operacji
    login({ commit }, credentials) {
      // W rzeczywistej aplikacji tutaj byłoby zapytanie do API
      return new Promise((resolve) => {
        setTimeout(() => {
          if (credentials.email === "demo@example.com" && credentials.password === "demo123") {
            const user = {
              name: "Jan Kowalski",
              email: credentials.email,
              company: "Kowalski sp. z o.o.",
              lastLogin: new Date().toLocaleString("pl-PL"),
            };
            commit("SET_USER", user);
            resolve({ success: true, user });
          } else {
            resolve({ success: false, message: "Nieprawidłowy email lub hasło." });
          }
        }, 1000);
      });
    },
    logout({ commit }) {
      commit("LOGOUT");
    },
  },
  modules: {
    // Tutaj możesz dodać moduły Vuex dla lepszej organizacji kodu
  },
});
